(function () {
  function initBrandSearch(root) {
    const input = root.querySelector('[data-pd-brand-search]');
    const list = root.querySelector('[data-pd-brand-list]');
    const empty = root.querySelector('[data-pd-brand-empty]');
    if (!input || !list) return;

    const items = Array.from(list.querySelectorAll('[data-pd-brand-item]'));
    const letters = Array.from(list.querySelectorAll('[data-pd-brand-letter]'));

    const filter = () => {
      const q = String(input.value || '')
        .trim()
        .toLowerCase();
      let visible = 0;
      const visibleLetters = new Set();

      items.forEach((item) => {
        const name = item.getAttribute('data-pd-brand-name') || '';
        const show = !q || name.includes(q);
        item.classList.toggle('is-hidden', !show);
        if (show) {
          visible += 1;
          const letter = name.charAt(0).toUpperCase();
          visibleLetters.add(letter);
        }
      });

      letters.forEach((el) => {
        const letter = el.getAttribute('data-pd-brand-letter') || el.textContent.trim();
        el.classList.toggle('is-hidden', q !== '' && !visibleLetters.has(letter));
      });

      if (empty) empty.hidden = visible > 0;
    };

    input.addEventListener('input', filter);
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        input.value = '';
        filter();
        input.blur();
      }
    });
  }

  function init() {
    document.querySelectorAll('.pd-brands-panel, .pd-brands-menu').forEach((root) => {
      const panel = root.classList.contains('pd-brands-panel') ? root : root.querySelector('.pd-brands-panel');
      if (panel) initBrandSearch(panel);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
